export default [
    {
        path: '/trial',
        name: 'mha.promo.trial',
        components: {
            default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/trial/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/components3/TheFooter')
        },
        props: true,
        meta: {
            linksToHide: ['join'],
            headerRegistrationButtonText: 'START 30-DAY TRIAL',
            promoId: "NZ48z",
            showArrow: false,
            isLandingPage: true
        },
    },
    // {
    //     path: '/promo/join',
    //     name: 'mha.promo.join',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/join/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/components3/TheFooter')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'JOIN NOW',
    //         showArrow: true,
    //         promoId: "48",
    //         isLandingPage: true
    //     }
    // },
    // {
    //     path: '/promo/renew',
    //     name: 'mha.promo.renew',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/eofy/eofy23/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/components3/TheFooter')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'RENEW NOW',
    //         showArrow: true,
    //         promoId: "22",
    //         isLandingPage: true
    //     }
    // },
//   {
//       path: '/promo/join',
//       name: 'mha.promo.eofy.join',
//       components: {
//           default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/eofy/eofy22/views/Index.vue'),
//           header: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/components/TheHeader.vue'),
//           footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
//       },
//       props: true,
//       meta: {
//           linksToHide: ['join'],
//           headerRegistrationButtonText: 'JOIN NOW',
//           showArrow: true,
//           isLandingPage: true,
//           promoId: "VNlvz",
//           isRenew: false
//       },
//   },
//   {
//       path: '/promo/renew',
//       name: 'mha.promo.eofy.renew',
//       components: {
//           default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/eofy/eofy22/views/Index.vue'),
//           header: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/components/TheHeader.vue'),
//           footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
//       },
//       props: true,
//       meta: {
//           linksToHide: ['join'],
//           headerRegistrationButtonText: 'RENEW NOW',
//           showArrow: true,
//           isLandingPage: true,
//           promoId: "VNlvz",
//           isRenew: true
//       },
//   },
]
